<section class="w-full flex flex-col">
    @if (currentUser) {
        <section class="w-full">
            <h1 class="font-display text-2xl font-bold text-text">Welcome back, {{ currentUser.firstName }}</h1>
            <p class="text-text">Heres whats happend in the last week</p>
        </section>
        <section class="grid-cols-1 md:grid-cols-2 gap-4">
            @for (skeleton of [1, 2, 3, 4]; track skeleton) {
                <p-skeleton width="100%" height="120px" borderRadius="12px"></p-skeleton>
            }
        </section>
    } @else {
        @for (skeleton of [1, 2, 3, 4]; track skeleton) {
            <p-skeleton width="100%" height="120px" borderRadius="12px"></p-skeleton>
        }
    }
</section>
